import { ReactNode, useContext, useEffect, useState } from "react";
import "./CompanyOnboardWrapper.scss";
import { useTranslation } from "react-i18next";
import GoogleIcon from "../../utils/Images/GoogleIcon";
import LogoTagline from "../../utils/Images/LogoTagline";
import { useGoogleLogin } from "@react-oauth/google";
import { getEntireCustomUrl } from "smartassess-api-lib";
import { TypeSelect, useOnlineStatus } from "ui-components";
import { useLocation, useNavigate } from "react-router-dom";
import i18n from "../../i18nConfig";
import handleApplicantLogin from "../../pages/Assessment/Auth/LoginApiCall";
import { linkedInConsts, redirectTo } from "../../utils/Common/Constant";
import LinkedinIcon from "../../utils/Images/LinkedinIcon";
import { CommonEnums } from "../../utils/Enums/CommonEnums";
import { initializeApiClient } from "../../service/Connection/Connection";
import { systemPreferenceContext } from "../../context/SystemPreference/SystemPreference";
interface props {
  children?: ReactNode;
  lowerSubmitText1?: string;
  lowerSubmitText2?: string;
  signInUpClick?: any;
  isGoogleSignBtn?: boolean;
  islogoVisible?: boolean;
  heading1?: string;
  heading2?: string;
  isOtpScreen?: boolean;
  emailId?: string;
  isLinkedInSignBtn?: boolean;
}
const CompanyOnboardWrapper: React.FC<props> = ({
  children,
  lowerSubmitText1,
  lowerSubmitText2,
  signInUpClick,
  isGoogleSignBtn,
  islogoVisible,
  heading1,
  heading2,
  isOtpScreen,
  emailId,
  isLinkedInSignBtn,
}) => {
  const { t } = useTranslation();
  const [user, setUser] = useState<any>([]);
  const isOnline = useOnlineStatus();
  const navigate = useNavigate();
  const currentLanguage = i18n.language;
  const referredClientEmail = sessionStorage.getItem("referredClientEmail");
  const referredPartnerId = sessionStorage.getItem("referredPartnerId");
  const route = useLocation();
  const rechargeSlabID = new URLSearchParams(location.search).get("sId");
  const templateID = new URLSearchParams(location.search).get("tempId");
  const [selectedLanguage, setSelectedLanguage] = useState(
    localStorage.getItem("currentLanguage") ?? CommonEnums.LANGUAGE_EN,
  );
  const { setCompanyToken } = useContext(systemPreferenceContext);
  const changeLanguage = (newLang: string) => {
    const currentPath = location.pathname;
    const updatedPath = currentPath.replace(/^\/[a-z]{2}/, `/${newLang}`);
    i18n.changeLanguage(newLang);
    initializeApiClient(newLang);
    navigate(updatedPath + location.search, {
      replace: true,
    });
  };
  const isLoginPage = () => {
    return route?.pathname?.split("/").includes("company-login");
  };
  const handleGoogleSignIn = useGoogleLogin({
    onSuccess: (credentialResponse) => {
      setUser(credentialResponse);
    },
    onError: () => {
      console.error("Login Failed");
    },
  });
  // get code while linkedin login
  const linkedInLogin = () => {
    const authUrl = `${linkedInConsts.authUrl}${
      process.env.REACT_APP_LINKEDIN_CLIENT_ID
    }&redirect_uri=${
      process.env.REACT_APP_LINKEDIN_REDIRECT_URI
    }&scope=${linkedInConsts.linkedInScope}`;
    window.location.replace(authUrl);
  };
  useEffect(() => {
    if (user.access_token) {
      getEntireCustomUrl(
        `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`,
        10000,
        {
          headers: {
            Authorization: `Bearer ${user.access_token}`,
            Accept: "application/json",
          },
        },
      )
        .then((res: any) => {
          //call login function and pass parameters
          handleApplicantLogin(
            res?.email,
            "",
            "Google",
            res?.id,
            res?.verified_email,
            () => {},
            () => {},
            navigate,
            currentLanguage,
            rechargeSlabID,
            templateID,
            res?.email?.toLowerCase() === referredClientEmail?.toLowerCase()
              ? referredPartnerId
              : null,
            setCompanyToken,
          );
        })
        .catch((err: any) => console.log(err));
    }
  }, [user]);
  return (
    <div className="container-fluid company-onboard-wrapper">
      {!isOnline && (
        <div className="internet-banner">
          <div className={`banner ${!isOnline ? "show zIndexTop" : ""}`}>
            {t("GENERAL.INTERNET_CONNECTION")}
          </div>
        </div>
      )}
      <div className={"onboardRow row no-gutters rowRev"}>
        <div className="col-xl-6 justify-content-left ">
          <div className="left-partition forWebBg" />
          <div className="forMvBg" />
        </div>
        <div className="col-xl-6 d-flex flex-column justify-content-center">
          <div className="languageSelectDropdown">
            <TypeSelect
              value={selectedLanguage}
              onChange={(value: any) => {
                localStorage.setItem("currentLanguage", value);
                changeLanguage(value);
                setSelectedLanguage(value);
              }}
              // label={t("GENERAL.SELECT_LANGUAGE")}
              options={[
                {
                  label: t("GENERAL.ENGLISH"),
                  value: CommonEnums.LANGUAGE_EN,
                },
                {
                  label: t("GENERAL.ARABIC"),
                  value: CommonEnums.LANGUAGE_AR,
                },
                // {
                //   label: t("GENERAL.SPANISH"),
                //   value: CommonEnums.LANGUAGE_ES,
                // },
              ]}
            />
          </div>
          <div className="right-partition">
            <div className="right-content">
              {!islogoVisible && (
                <div className="logo-header ">
                  <div className="logo">
                    <LogoTagline />
                  </div>
                </div>
              )}
              {heading1 || heading2 || isOtpScreen ? (
                <div className="heading-division">
                  <h4 className="userHeadingApp">{heading1}</h4>
                  <h1 className="userHeading">{heading2}</h1>
                </div>
              ) : (
                <></>
              )}
              {isLinkedInSignBtn && (
                <>
                  <div className="googleSignIn" onClick={() => linkedInLogin()}>
                    <LinkedinIcon />
                    <span>{t("GENERAL.CONTINUE_WITH_LINKEDIN")}</span>
                  </div>
                </>
              )}
              {isGoogleSignBtn && (
                <>
                  <div
                    className="googleSignIn"
                    onClick={() => handleGoogleSignIn()}
                  >
                    <GoogleIcon />
                    <span>{t("GENERAL.CONTINUE_WITH_GOOGLE")}</span>
                  </div>
                  <div className="divider my-3">{t("GENERAL.OR")}</div>
                </>
              )}
              {isOtpScreen && (
                <div className="confirm-otp-text">
                  <span>{t("GENERAL.ENTER_OTP")} </span>
                  <p>
                    <b>{emailId}</b>
                  </p>
                </div>
              )}
              {children}
              <p
                className={`text-center mt-3 account_signup ${!isGoogleSignBtn && "account_signupCreatePassword"}`}
              >
                {lowerSubmitText1}
                <span onClick={signInUpClick}> {lowerSubmitText2}</span>
              </p>
            </div>
            {isLoginPage() && (
              <div className="bottomLinks">
                <span
                  onClick={() =>
                    redirectTo("https://evluate.com/privacy-policy.php")
                  }
                >
                  {" "}
                  {t("GENEREAL.PRIVACY_POLICY")}
                </span>
                <div>|</div>
                <span
                  onClick={() =>
                    redirectTo("https://evluate.com/terms-and-use.php")
                  }
                >
                  {t("GENEREAL.TERM_OF_USE")}{" "}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyOnboardWrapper;
